export default {
  app: {
    place: {
      address: '주소',
      showOnExternalMaps: '구글 지도에서 보기',
    },
  },
};
